import script from "./SuggestedCalculation.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestedCalculation.vue?vue&type=script&setup=true&lang=ts"

import "./SuggestedCalculation.vue?vue&type=style&index=0&id=73023de7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73023de7"]])

export default __exports__